import React from 'react';

import { useTableContext } from 'lib/context/TableContext/TableContext';

import CustomPagination from '../CustomPagination/CustomPagination';

export const CustomStatusBarPagination = ({ data = [], count, pageCountOverride }) => {
  const { page, onPageChange, limit = 25 } = useTableContext();
  return (
    <div className="bg-red flex h-full flex-wrap items-center space-x-4 text-sm">
      {data?.length > 0 ? (
        <CustomPagination
          onPageChange={onPageChange}
          perPage={limit}
          totalItems={count || 1}
          page={page}
          pageCountOverride={pageCountOverride}
        />
      ) : null}
    </div>
  );
};
